import { render } from "./CreateBookForm.vue?vue&type=template&id=efebaf04"
import script from "./CreateBookForm.vue?vue&type=script&lang=js"
export * from "./CreateBookForm.vue?vue&type=script&lang=js"

import "./CreateBookForm.vue?vue&type=style&index=0&id=efebaf04&lang=css"

import exportComponent from "D:\\CSS and HTML\\Internship - elmawkaa\\My-Book-List\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__